import React, { useContext, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { MobileContext } from "../../contexts/MobileContext";
import { MenuContext } from "../../contexts/MenuContext";
import { StyledMenu } from "../../styled-components/StyledMenu.style";
import logo from "../../assets/crt_20_anos_w.png";
import logosvg from "../../assets/crt-20-anos-w.svg";
import {
    IconDash,
    IconTask,
    IconTicket,
    IconHouse,
    IconBag,
    IconMoney,
    IconTimer,
    IconSheet,
    IconClock,
    IconLanguage,
    IconConfig,
    IconUser,
    IconRegister,
    IconAviso,
    IconBullseye,
    IconInvoice,
    IconOS,
    IconClipboarCheck,
    IconTableList,
    IconMedal,
    IconCircleFull,
    IconChartDiagram,
    IconCalenderMenu
} from "../../svg";
import moment from "moment";


const MenuIcon = (props) => {
    const { index, icon, color } = props;


    const listItens = {
        "IconDash": <IconDash color={color} />,
        "IconTask": <IconTask color={color} />,
        "IconTicket": <IconTicket color={color} />,
        "IconHouse": <IconHouse color={color} />,
        "IconBag": <IconBag color={color} />,
        "IconMoney": <IconMoney color={color} />,
        "IconTimer": <IconTimer color={color} />,
        "IconSheet": <IconSheet color={color} />,
        "IconClock": <IconClock color={color} />,
        "IconLanguage": <IconLanguage color={color} />,
        "IconConfig": <IconConfig color={color} />,
        "IconUser": <IconUser color={color} />,
        "IconAviso": <IconAviso color={color} />,
        "IconRegister": <IconRegister color={color} />,
        "IconBullseye": <IconBullseye color={color} />,
        "IconInvoice": <IconInvoice color={color} />,
        "IconOS": <IconOS color={color} />,
        "IconClipboarCheck": <IconClipboarCheck color={color} />,
        "IconTableList": <IconTableList color={color} />,
        "IconMedal": <IconMedal color={color} />,
        "IconCircleFull": <IconCircleFull color={color} />,
        "IconChartDiagram": <IconChartDiagram color={color} />,
        "IconCalenderMenu": <IconCalenderMenu color={color} />
    }

    const rst = listItens[icon];

    return rst ? rst : <IconRegister color={color} />;
};


export const Menu = () => {
    const [itemHover, setItemHover] = useState(-1);
    const [itemCollapsed, setItemCollapsed] = useState(-1);
    const currentRoute = useLocation();
    const isMobile = useContext(MobileContext);
    const menContext = useContext(MenuContext);


    const routeContains = (route, currentRoute, index) => {
        const regex = new RegExp(route?.link, "i");
        if(!route?.link && (!route?.menus || route?.menus?.length === 0)) return false
        return (route?.link && (route?.link === currentRoute)) || routeContainsSub(route, currentRoute, index);
        //return false;
    };

    const routeContainsSub = (route, currentRoute, index) => {

        if (!route?.menus || route?.menus?.length === 0) {
            return false;
        }
        const regex = new RegExp(route?.link, "i");
        const fTeste = route?.menus?.filter(element => (element.link === currentRoute));
        // setItemCollapsed(fTeste && index && fTeste?.length > 0 ? index : -1);
        return fTeste.length > 0;
    };


    return (
        <StyledMenu isMobile={isMobile}>
            {menContext.map((item, i) => {
                return (
                    <div key={i}>{(!item?.menus || item?.menus?.length === 0)}
                        {!item?.menus || item?.menus?.length === 0 ? <Link
                            to={item.link}
                        >
                            <div
                                className="d-flex my-1 interLink"
                                
                                onClick={() =>
                                    setItemCollapsed(
                                        i === itemCollapsed ? -1 : i
                                    )
                                }
                                onMouseEnter={() => setItemHover(i)}
                                onMouseLeave={() => setItemHover(-1)}
                            >
                                <div className="icon-item">
                                    <span> {routeContains(item, currentRoute.pathname, i)}</span>
                                    <MenuIcon
                                        index={i}
                                        icon={item.icon}
                                        color={
                                            itemHover === i ||
                                                routeContains(item, currentRoute.pathname, i)
                                                ? "#EF4623"
                                                : "#fff"
                                        } />
                                </div>
                                <span
                                    className={
                                        routeContains(item, currentRoute.pathname, i)
                                            ? "text-orange"
                                            : ""
                                    }
                                >
                                {item.nameMenu}
                                </span>
                            </div>
                        </Link> : <span
                            to={item.link}
                        >
                            <div
                                className="d-flex mt-1 interLink"
                                onClick={() =>
                                    setItemCollapsed(
                                        i === itemCollapsed ? -1 : i
                                    )
                                }
                                onMouseEnter={() => setItemHover(i)}
                                onMouseLeave={() => setItemHover(-1)}
                            >
                                <div className="icon-item">
                                    <span> {routeContains(item, currentRoute.pathname)}</span>
                                    <MenuIcon
                                        index={i}
                                        icon={item.icon}
                                        color={
                                            itemHover === i
                                                ? "#EF4623" //#EF4623
                                                : "#fff"
                                        } />
                                </div>
                                <span
                                    className={
                                        routeContains(item, currentRoute.pathname, i)
                                            ? "" //text-orange
                                            : ""
                                    }
                                >
                                    {item.nameMenu}
                                </span>
                            </div>
                        </span>
                        }

                        {itemCollapsed === i
                            ? item.menus.filter(m=> m.acesso == true).map((sub, iSub) => {
                                return (
                                    <div key={`${i}${iSub}`} className="bg-sub">
                                        <Link
                                            to={sub.link}
                                        >
                                            <div
                                                className="d-flex align-items-center icon-row"
                                                onMouseEnter={() =>
                                                    setItemHover(`${i}${iSub}`)
                                                }
                                                onMouseLeave={() =>
                                                    setItemHover(-1)
                                                }
                                            >
                                                <div className="icon-item icon-sub ml-2">
                                                    <span> {routeContains(sub, currentRoute.pathname, iSub)}</span>
                                                        <MenuIcon
                                                            index={iSub}
                                                            icon={sub.icon}
                                                            color={
                                                                itemHover === iSub ||
                                                                    routeContains(sub, currentRoute.pathname, iSub)
                                                                    ? "#EF4623"
                                                                    : "#fff"
                                                            } />
                                                </div>
                                                <span
                                                    className={
                                                        currentRoute.pathname ===
                                                            sub.link
                                                            ? "text-orange"
                                                            : ""
                                                    }
                                                >
                                                    {sub.nameMenu}
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                );

                            })
                            : ""}
                    </div>
                );
            })}
            <div className="logo-row-menu" title={`Todos os direitos reservados Siscope® ${moment().format('YYYY')}`}>
                <img
                    className="logo-img-menu img-fluid"
                    src={logosvg}
                    alt="Siscope"
                    title={`Todos os direitos reservados Siscope® ${moment().format('YYYY')}`}
                />
            </div>
        </StyledMenu>
    );
};

